import { render, staticRenderFns } from "./T7.vue?vue&type=template&id=2fc785fb&"
import script from "./T7.vue?vue&type=script&lang=js&"
export * from "./T7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports